import React from 'react';
import docDesignerHOC from '../docDesigner';

function ShipNotes() {
	return <div className="doc-designer">ShipNotes Design</div>;
}

const designerHOC = docDesignerHOC(ShipNotes);

export default designerHOC;
